export const appSorters = {
    name: {path: "name", order: "ascending"},
    date: {path: "versions.0.date", order: "descending"},
};
